import React, { memo } from 'react'
import tw from 'twin.macro'
import { DateTime } from 'luxon'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'

interface Props {
  isOpen: boolean
  expiresAt: string
  isSubmitting: boolean
  onConfirm(): void
  onClose(): void
}

const ApproveMcDocumentModalComponent = ({
  isOpen,
  expiresAt,
  isSubmitting,
  onConfirm,
  onClose,
}: Props) => {
  const expiration = expiresAt === '' ? null : DateTime.fromISO(expiresAt)
  const isFuture = Boolean(expiration?.isValid && expiration > DateTime.now())

  return (
    <CommonModal
      isOpen={isOpen}
      title="Approve this document?"
      text="The master contractor is notified once this is approved."
      onClose={onClose}
      buttons={
        <div css={tw`flex flex-row gap-2`}>
          <Button color="white" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isSubmitting} data-testid="approve-confirm-button">
            Approve
          </Button>
        </div>
      }
    >
      {expiration?.isValid ? (
        <Typography variant="body2" css={isFuture ? tw`text-shades-900` : tw`text-critical-500`}>
          Expires {expiration.toFormat('MMM d, yyyy')}
          {isFuture ? '' : ' — this date is in the past'}
        </Typography>
      ) : (
        <Typography variant="body2" css={tw`text-shades-500`}>
          No expiration date recorded.
        </Typography>
      )}
    </CommonModal>
  )
}

export const ApproveMcDocumentModal = memo(ApproveMcDocumentModalComponent)
